import { actions, reducer as article, selectors } from './store';

export { default } from './Article';
export const store = { actions, reducers: { article }, selectors };
